<template>
	<div id="xc-model" ref="model">
		<div id="xc-room" class="po" @touchstart="down" @touchmove="move" @touchend="up">
			<div id="xc-panorama" class="po" :style="{ transform: 'rotateY('+rotateDeg+'deg)' }">
				<RoomTop :theme="mode['room']"></RoomTop>
					
				<div :key="image+'-'+index" v-for="(image, index) in timages" class="po xc-panorama_c" :class="getClass(index)" :style="{backgroundImage: 'url('+image['im']+')'}" @click="wxPreview(image)">
					<img v-if="mode['border']" :src="mode['border']">
					<!-- 字幕 -->
					<UserText 
						:mode="mode['mode'] || {}" 
						:currentText="image['tx']" 
						from="xc"></UserText>
				</div>

				<RoomBottom :theme="mode['room']"></RoomBottom>
			</div>
		</div>
		<Room2 v-if="mode['room2']" :mode="mode['room2']" :rotateDeg="rotateDeg" :currentImage="timages[0]"></Room2>
		<Room3 v-if="mode['room3']" :mode="mode['room3']"></Room3>

		<!-- 场内元素decorate -->
		<template v-if="mode['mode']">
			<template v-if="mode['mode']['decorate']">
				<template v-for="(decorate, decorate_id) in mode['mode']['decorate']">
					<template v-if="decorate_id == 'gif'">
						<template v-for="item in decorate">
							<gif :mode="item"></gif>
						</template>
					</template>
					<template v-else-if="decorate_id == 'elems'">
						<template v-for="item in decorate">
							<elem :mode="item"></elem>
						</template>
					</template>
					<template v-else>
						<component :is="decorate_id" :mode="decorate"></component>
					</template>
				</template>
			</template>
		</template>

		<template v-if="mode['texts']">
			<div class="xc-text">
				<template v-for="(texts, index) in mode['texts']">
					<div class="xc-text-con" :class="{'xc-text-show': textIdx%textNum == index}">
						<div v-for="text in texts" :style="{color: text[1]}">
							{{text[0]}}
						</div>
					</div>
				</template>
			</div>
		</template>

		<!-- 开场动画 -->
		<Prelude :mode="prelude" @preluded="preluded"></Prelude>
	</div>
</template>

<script>

	import Room2 from './room2/room2'
	import Room3 from './room3/room3'

	import RoomTop from './room/RoomTop'
	import RoomBottom from './room/RoomBottom'

	import Prelude from '../../comps/prelude/Prelude'
	import UserText from '../../comps/usertext/UserText'

	const prelude_duration = 3; // 默认开场

	let G = {
		imagesIndent: 4,
		images: [],
	}

	export default {
		name: 'xc',
		data () {
			return {
				rotateDeg: 0,
				imageShow: true,
				timages: [], // 当前相册中的照片组（4个一组）

				drag: false,
				speed: .5,
				r: 0,
				brake: 1,
				o: null,
				x: null,
				time: null,
			
				imageIdx: 0,

				textIdx: 0,
				textNum: 3,
				textEvent: null,
			}
		},
		props: ['mode'],
		computed: {
			prelude () {
				let prelude = Boolean(this.mode['prelude']) ? this.mode['prelude'] : false;
				if (!prelude) {
					// prelude = {
					// 	'type': 'default',
					// 	'duration': prelude_duration
					// }
					prelude = {}
				}
				if (this.mode['is_prelude'] === false) {
					prelude = {
						'type': 'none',
						'duration': 0
					}
				}
				prelude['title'] = this.$store.state['data']['ti'] || this.mode['name'];
				if (!prelude['textcolor']) {
					// prelude['textcolor'] = '#ed5100';
					prelude['textcolor'] = '#066f06';
				}
				if (!prelude['type']) {
					prelude['type'] = 'default';
				}
				if (!prelude['duration']) {
					prelude['duration'] = prelude_duration;
				}
				return prelude;
			},
		},
		components: {
			Room2,
			Room3,
			RoomTop,
			RoomBottom,
			Prelude,
			UserText,
		},
		mounted () {
			this.$refs.model.addEventListener('touchmove', function(e) {
				e.preventDefault();
			})

			this.spin();
		},
		created () {
			G.images = this.getImagesArray(this.$store.state.images, G.imagesIndent);
			
			this.imageIdx = G.images.length * 1000000000;

			let next_timages;

			[this.timages, next_timages, this.imageIdx] = this.getViewImages(G.images, this.imageIdx, this.speed);

			// 加载下一组照片
			// this._preloadNextPhotos(next_timages);

			// text模板配字
			this.textIdx = 0;
			clearInterval(this.textEvent);
			setTimeout(() => {
				this.textEvent = setInterval(() => {
					this.textIdx ++;
				}, 8000);
			}, 2000);
		},
		methods: {
			getClass (index) {
				let c = {
					'fadeOut': !this.imageShow,
					'fadeIn': this.imageShow
				};
				c['xc-panorama_c'+index] = true;
				return c;
			},
			wxPreview (photo) {
				this.$util.tdCall({
					action: "preview",
					data: "open",
					photo: photo
				});
			},
			spin () {
				if ( !this.drag ) {

					if ( this.r * 180 / 400 < -360 || this.r * 180 / 400 > 360 ) {
						this.r = 0;
						if (G.images.length > 1) {
							this.imageShow = false;
							setTimeout(() => {

								let timages = [];
								let next_timages;
								[timages, next_timages, this.imageIdx] = this.getViewImages(G.images, this.imageIdx, this.speed);

								// 预加载下一张用户图片
								// this._preloadNextPhotos(next_timages);

								for (let j=0,jlens=timages.length; j<jlens; j++) {
									this.$set(this.timages, j, timages[j]);
								}
								setTimeout(() => {
									this.imageShow = true;
								}, 200)
							}, 200);
						}
					}

					if ( this.speed < .5 && this.speed > 0 ) {
						this.speed = .5;
					} else if ( this.speed > -.5 && this.speed < 0 ) {
						this.speed = -.5;
					}

					this.r += this.speed;
					this.speed /= this.brake;
					
					let ry = (this.r * 180 / 400);
					this.rotateDeg = ry;
				}
				requestAnimationFrame(this.spin);
			},
			down (event) {
				this.o = this.r;
				this.x = this.r + event.touches[0].clientX;
				this.drag = true;
				this.time = new Date();
			},
			move (event) {
				if (this.drag) {
					let ry = (this.r * 180 / 400);
					this.r = this.x - event.touches[0].clientX;
					this.rotateDeg = ry;
				}
			},
			up (event) {
				if (this.drag) {
					let time = new Date() - this.time;
					let path = this.r - this.o;
					this.speed = path / time * 5;
					this.brake = 1.01;
					this.drag = false;
				}
			},
			getImagesArray (images, indent) {
				images = this.$util.copy(images);
				let lens = images.length,
					maxlen = Math.ceil(images.length / indent) * indent;

				// 补充图片组
				// for (let i=0; i<maxlen; i++) {
				// 	if (!images[i]) {
				// 		images.push( images[i%lens] );
				// 	}
				// }

				// 均分图片组
				let slice_images = [];
				for (let i=0; i<images.length; i+=indent) {
					let ims = images.slice( i, i+indent );
					slice_images.push(ims);
				}

				// 补全尾数
				if (slice_images.length == 1) {
					for (let i=0; i<indent; i++) {
						if (!slice_images[0][i]) {
							slice_images[0].push( slice_images[0][i%slice_images[0].length] );
						}
					}
				} else {
					let last_images = slice_images[ slice_images.length - 1 ];
					if (last_images.length != indent) {
						let last_images_2 = slice_images[ slice_images.length - 2 ];
						let temp_images = last_images_2.slice(last_images.length);
						last_images = temp_images.concat(last_images);
						slice_images[slice_images.length-1] = last_images;
						// debugger;
					}
				}

				return slice_images;
			},
			getViewImages (slice_images, image_idx, speed) {
				slice_images = this.$util.copy(slice_images);
				let view_images = slice_images[ image_idx%slice_images.length ];

				let last_view_images, next_view_images, last_idx, next_idx;
				let preload_view_images = [];

				last_idx = image_idx - 1;
				next_idx = image_idx + 1;
				next_view_images = slice_images[ next_idx%slice_images.length ];
				last_view_images = slice_images[ last_idx%slice_images.length ];

				if (speed <= 0) { // 若反向滑动，则数组逆序
					image_idx --;
					if (image_idx <= 0) {
						image_idx = slice_images.length * 1000000000;
					}
				} else {
					image_idx ++;
				}

				try {
					preload_view_images = preload_view_images.concat(next_view_images);
				} catch(e) {}
				try {
					preload_view_images = preload_view_images.concat(last_view_images);
				} catch(e) {}

				return [ view_images, preload_view_images , image_idx ];
			},
			// 预加载下一张用户图片
			// _preloadNextPhotos (photos) {

			// 	let _this = this;

			// 	for (let i=0; i<photos.length; i++) {

			// 		let photo = photos[i];

			// 		let im = new Image();
					
			// 		im.onload = (function(_photo) {
			// 			return function() {
			// 				_this.$store.commit('setImageOriSize', {'imageid': _photo['id'], 'orisize': [this.width, this.height]});
			// 			}
			// 		})(photo);
			// 		im.onerror = (function(_photo) {
			// 			return function() {
			// 				_this.$store.commit('setImageOriSize', {'imageid': _photo['id'], 'orisize': [500, 500]});
			// 			}
			// 		})(photo);

			// 		im.src = photo['im'];
			// 	}
			// },
			preluded () {}
		}
	}
</script>

<style>
	.xc-text {
		position: fixed;
		width: 415.00px;
		height: 210.00px;
		z-index: 2;
		bottom: 100.00px;
		left: 50%;
		margin-left: -225.00px;
		font-size: 35.00px;
		pointer-events: none;
		background-color: rgba(0,0,0,.2);
		box-shadow: 0 0 15.00px 5.00px rgba(0,0,0,.2);
	}
	.xc-text-con {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		display: flex;
		flex-direction: column;
		justify-content: space-evenly;
		align-items: center;
		opacity: 0;
		transition: opacity 2s;
	}
	.xc-text-con>div {
		font-weight: bold;
		font-family: 'Heiti';
		text-shadow: 2px 2px 5px #000;
	}

	#xc-model {
		overflow: hidden;
	}
	
	#xc-room {
		height: 100%; width: 100%;
		perspective: 415.00px;
		overflow: hidden;
	}
	#xc-panorama {
		width: 500px;
		height: 500px;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
		transform-style: preserve-3d;
		cursor: pointer;
	}
	.xc-panorama_c, .xc-panorama_m {
		width: 500px;
		height: 500px;
		background-size: cover;
		backface-visibility: hidden;
		-webkit-backface-visibility: hidden;
		transform-style: preserve-3d;
	}
	.xc-panorama_c img {
		position: absolute;
		z-index: 10;
		width: 100%;
		height: 100%;
	}
	.xc-panorama_c span {
		position: absolute;
		width: 465.00px;
		left: 0;
		right: 0;
		text-align: center;
		margin: auto;
		bottom: 30.00px;
		color: white;
		font-size: 43.00px;
		text-shadow: 2px 2px 10px black;
		font-family: '\9ED1\4F53';
		font-weight: bold;
	}
	.xc-panorama_c {
		background-position: center 15%;
		transition: opacity .5s linear;
	}
	.xc-panorama_m {
		background-position: center center;
	}
	.xc-panorama_top {
		transform: rotateX(-90deg) translateZ(-250.00px);
		overflow: hidden;
	}
	.xc-panorama_bottom {
		transform: rotateX(90deg) translateZ(-250.00px);
		overflow: hidden;
	}
	.xc-panorama_c0 {
		transform: translateZ(-243.00px);
	}
	.xc-panorama_c1 {
		transform: rotateY(-90deg) translateZ(-243.00px);
	}
	.xc-panorama_c2 {
		transform: rotateY(180deg) translateZ(-243.00px);
	}
	.xc-panorama_c3 {
		transform: rotateY(90deg) translateZ(-243.00px);
	}

	.xc-images-leave {
		opacity: 1;
	}
	.xc-images-leave-to {
		opacity: 0;
	}

	.xc-images-enter {
		opacity: 0;
	}
	.xc-images-enter-to {
		opacity: 1;
	}

	.xc-text-show {
		opacity: 1!important;
	}
	
</style>







